<template>
  <div>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <b-row >
      <b-col>
        <span style="font-size: 18px"> <b> DATA ANALYTICS </b></span>
      </b-col>
      <b-col cols="12" class="pt-3">
        <div v-if="userType == 0" class="row">
          <div class="flex xs12 sm3">
            <router-link to="/users/all">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalUsers }}
                </p>
                <p style="font-size: 16px">Total Users</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/reportslist/nodata">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalCrimeReports }}
                </p>
                <p style="font-size: 16px">Total Crime Reports</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="users/pending">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.pendingUsers }}
                </p>
                <p style="font-size: 16px">Pending Users</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/reportslist/Pending">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.pendingCrimeReports }}
                </p>
                <p style="font-size: 16px">Pending Crime Reports</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/listRecords">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalDigitalGuide }}
                </p>
                <p style="font-size: 16px">Digital Guides</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/listqueries">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalContactAdmins }}
                </p>
                <p style="font-size: 16px">Queries</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/enquirylist">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalEnquiries }}
                </p>
                <p style="font-size: 16px">Enquiries</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/guidelist">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalIdentificationGuide }}
                </p>
                <p style="font-size: 16px">Identification Guides</p>
              </va-card>
            </router-link>
          </div>

          <div class="flex xs12 sm3">
            <router-link to="/speciesSchedule">
              <va-card class="mb-3 clr">
                <!-- <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalIdentificationGuide }}
                </p> -->
                <p style="font-size: 16px">Species Schedules</p>
              </va-card>
            </router-link>
          </div>
          <!-- <div class="flex xs12 sm3">
            <router-link to="/">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalIdentificationGuide }}
                </p>
                <p style="font-size: 16px">Species Schedules</p>
              </va-card>
            </router-link>
          </div> -->

          
        </div>

        

        <div v-if="userType == 2" class="row">
          <div class="flex xs12 sm3">
            <router-link to="/reportslist/nodata">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalAssignedCrimeReports }}
                </p>
                <p style="font-size: 16px">Total Crime Reports</p>
              </va-card>
            </router-link>
          </div>

          <div class="flex xs12 sm3">
            <router-link to="/reportslist/Pending">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.assigned_pendingCrimeReports }}
                </p>
                <p style="font-size: 16px">Pending Crime Reports</p>
              </va-card>
            </router-link>
          </div>
          <div class="flex xs12 sm3">
            <router-link to="/listRecords">
              <va-card class="mb-3 clr">
                <p class="mb-0" style="font-size: 40px; color: white">
                  {{ analytics.totalDigitalGuide }}
                </p>
                <p style="font-size: 16px">Digital Guides</p>
              </va-card>
            </router-link>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import { debounce } from "lodash";
import data from "../markup-tables/data.json";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      users: data.slice(),
      visible: false,
      term: null,
      analytics: [],
      mode: 0,
      msg: "",
      userType: localStorage.getItem("userType"),
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:icon",
          width: "30px",
          dataClass: "text-center",
        },
        {
          name: "name",
          title: this.$t("tables.headings.name"),
          width: "30%",
        },
        {
          name: "email",
          title: this.$t("tables.headings.email"),
          width: "40%",
        },
        {
          name: "__slot:status",
          title: this.$t("tables.headings.status"),
          width: "30%",
          sortField: "status",
        },
        {
          name: "__slot:actions",
          dataClass: "text-right",
        },
      ];
    },
    modeOptions() {
      return [
        {
          value: 0,
          label: this.$t("dashboard.table.brief"),
        },
        {
          value: 1,
          label: this.$t("dashboard.table.detailed"),
        },
      ];
    },
    filteredData() {
      if (!this.term || this.term.length < 1) {
        return this.users;
      }
      return this.users.filter((item) => {
        return item.name.toLowerCase().startsWith(this.term.toLowerCase());
      });
    },
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.visible = true;
      axios({
        method: "POST",
        url: "/admin/analytics",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: { type: "pending" },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.analytics = response.data.data;
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
            this.msg = "No Data Found!!";
          }
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    getStatusColor(status) {
      if (status === "accepted") {
        return "success";
      }
      if (status === "processing") {
        return "info";
      }
      return "danger";
    },
    resolveUser(user) {
      this.loading = true;
      setTimeout(() => {
        const idx = this.users.findIndex((u) => u.id === user.id);
        this.users.splice(idx, 1);
        this.loading = false;
        this.showToast(this.$t("dashboard.table.resolved"), {
          icon: "fa-check",
          position: "bottom-right",
          duration: 1500,
        });
      }, 500);
    },
    search: debounce(function (term) {
      this.term = term;
    }, 400),
  },
};
</script>

<style lang="scss">
.row-separated {
  .flex + .flex {
    border-left: 1px solid #e3eaeb;
  }
  @include media-breakpoint-down(xs) {
    p:not(.display-2) {
      font-size: 0.875rem;
    }
  }
}
.dashboard {
  .va-card__header--over {
    @include media-breakpoint-up(md) {
      padding-top: 0 !important;
    }
  }
}
.clr {
  background-color: #000000;
  background-image: linear-gradient(147deg, #000000 0%, #434343 74%);
  color: white !important;
}
</style>